import React from "react";
import TableData from "../../../../_components/TableData";
import LoadingContainer from "../../../../_components/LoadingContainer";
import { Modal } from "react-bootstrap"
import Button from '../../../../_components/Button'
import { FormControl } from "react-bootstrap"
import Text from "../../../../_components/Text";
import { createSupplier, getSuppliers, updateSupplier, ToogleActivationSupplier } from "../../../../api/suppliers";
import { toast } from "react-toastify"
import Dropdown, { DropDownDivider, DropDownItem } from "../../../../_components/Dropdown";
import Dialog from "../../../Fiscal/NFe/Issuer/Dialog";

export default props => {
    const [data, setData] = React.useState([])

    const [loading, setLoading] = React.useState(false)
    const [supplierData, setSupplierData] = React.useState({})
    const [currentSupplyer, setCurrentSupplyer] = React.useState({})
    const [show, setShow] = React.useState(false)
    const [showEdit, setShowEdit] = React.useState(false)

    
    async function getData(params = { is_active: true }) {

        setLoading(true)
        await getSuppliers(params)
            .then(result => {

                result = result.reverse().map((mappedItem, index) => {
                    return {
                        ...mappedItem,

                        name: mappedItem.name,
                        email: mappedItem.email,
                        phone_number: mappedItem.phone_number,
                        address: mappedItem.address,
                        actions: <Dropdown>

                            <DropDownItem>
                                <Button
                                    as="text"
                                    className="mx-1"
                                    onClick={() => {
                                        setShowEdit(true)
                                        delete mappedItem.address
                                        setSupplierData(mappedItem)
                                        setCurrentSupplyer(mappedItem)
                                    }}

                                >
                                    <i className="fa fa-edit" />{" "}
                                    <span>Editar Fornecedor</span>
                                </Button>
                            </DropDownItem>

                            <DropDownDivider></DropDownDivider>

                            <DropDownItem>
                                <Button
                                    as="text"
                                    className="text-danger mx-1"
                                    onClick={() => {
                                        ToogleActivationSupplier(mappedItem.id)
                                    }}
                                >
                                    <i className="fa fa-edit" />{" "}
                                    <span>Desativar Fornecedor</span>
                                </Button>
                            </DropDownItem>

                        </Dropdown>

                    }
                })
                setData(result)
            })

        setLoading(false)
    }

    function updateSupplierData() {
        updateSupplier(supplierData.id, supplierData)
            .then(aquele => {
                toast.success("Fornecedor Editado", {
                    position: "top-center"
                })
                setTimeout(() => {
                    window.location.reload()

                }, 2000)
            })
    }

    function onHandleShow() {
        if (loading) {
            return
        }
        setShow(!show)
    }

    function onChange(e) {

        let { name, value } = e.target
        let tempData = { ...supplierData }
        tempData[name] = value
        setSupplierData(tempData)
    }

    React.useEffect(() => getData(), [])

    return <LoadingContainer loading={loading}>
        <div className="mb-2">
            <p className="lead mb-1 pb-1">
                Fornecedores
            </p>
            <Button
                className="px-3"
                size="sm"
                onClick={onHandleShow}
                loading={loading}
                variant="primary">
                <i className="fas fa-plus"></i> Cadastrar Fornecedor
            </Button>
        </div>
        <TableData
            data={data}
            tHead={["Nome", "E-mail", "Telefone", "Ações"]}
            tBodyKeys={["name", "email", "phone_number", "actions"]}
        />




        <Modal title="Conta a Pagar" onHide={onHandleShow} show={show}>
            <div className="container row" id="modal-create">
                <div className="col-12">
                    <div className="text-center m-0 py-2">
                        <span className=""></span>
                    </div>
                </div>

                <div className="col-lg-6 col-sm-12">
                    <div className="form-group">

                        <div>
                            <div>
                                <Text color='primary'>
                                    Nome:
                                </Text>
                            </div>
                            <FormControl
                                name='name'
                                placeholder='Insira um nome'
                                disabled={loading}
                                onChange={onChange}
                                value={currentSupplyer.name}
                            />
                        </div>
                    </div>
                </div>

                <div className="col-lg-6 col-sm-12">
                    <div className="form-group">

                        <div>
                            <div>
                                <Text color='primary'>
                                    E-mail:
                                </Text>
                            </div>
                            <FormControl
                                name='email'
                                placeholder='Insira um nome'
                                disabled={loading}
                                onChange={onChange}
                                type="email"
                                value={supplierData.email}
                            />
                        </div>
                    </div>
                </div>

                <div className="col-lg-6 col-sm-12">
                    <div className="form-group">

                        <div>
                            <div>
                                <Text color='primary'>
                                    Telefone:
                                </Text>
                            </div>
                            <FormControl
                                name='phone_number'
                                placeholder='Insira um nome'
                                disabled={loading}
                                onChange={onChange}
                                type="decimal"
                                maxLength={9}
                                value={supplierData.phone_number}
                            />
                        </div>
                    </div>
                </div>

                <div className="col-lg-12">
                    <div className="d-flex justify-content-center">
                        <Button
                            disabled={supplierData.name ? false : true}
                            onClick={() =>
                                createSupplier(supplierData)
                                    .then(() => {
                                        toast.success("Fornecedor cadastrado!.", { position: "top-center" })
                                        setTimeout(() => { window.location.reload() }, 2000)

                                    })
                                    .catch(() => {
                                        toast.error("Erro ao cadastrar fornecedor!.", { position: "top-center" })

                                    })
                            }
                        >
                            Cadastrar
                        </Button>
                    </div>
                </div>
            </div>
        </Modal>

        <Dialog onHide={() => { setShowEdit(false) }} show={showEdit} type={"info"}>
            <h2>Editar {supplierData.name}</h2>

            <div className='col-12'>
                <div className='form-group'>
                    <div>
                        <div>
                            <Text color='primary'>
                                Novo Nome
                            </Text>
                        </div>
                        <div>

                            <FormControl
                                required
                                name='name'
                                placeholder='Insira o novo nome'
                                disabled={loading}
                                onChange={onChange}
                                value={supplierData.name}
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div className='col-12'>
                <div className='form-group'>
                    <div>
                        <div>
                            <Text color='primary'>
                                Novo Telefone
                            </Text>
                        </div>
                        <div>

                            <FormControl
                                type='number'
                                name='phone_number'
                                placeholder='Insira o novo telefone'
                                disabled={loading}
                                onChange={onChange}
                                value={supplierData.phone_number}
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div className='col-12'>
                <div className='form-group'>
                    <div>
                        <div>
                            <Text color='primary'>
                                Novo Email
                            </Text>
                        </div>
                        <div>

                            <FormControl
                                required
                                name='email'
                                placeholder='Insira o novo email'
                                disabled={loading}
                                onChange={onChange}
                                value={supplierData.email}
                            />
                        </div>
                    </div>
                </div>
            </div>

            <Button onClick={updateSupplierData}>
                Confirmar
            </Button>
        </Dialog>

    </LoadingContainer>
}


// WEBPACK FOOTER //
// ./src/views/AppViews/Products/Suppliers/index.jsx